import { ArrowRight, BookOpen, ClipboardList, Globe2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/lib/locale-link";
import { track } from "@/lib/analytics";
import { useTranslation } from "@/hooks/useTranslation";
import { CONSUMER_JOIN_ROUTE, REGISTRY_ROUTE } from "@/lib/homepage-ctas";

export function MobileCtaValueProps() {
  const { t } = useTranslation();

  const valueProps = [
    { icon: BookOpen, title: t("mobileCta.valueProp1Title"), body: t("mobileCta.valueProp1Body") },
    { icon: ClipboardList, title: t("mobileCta.valueProp2Title"), body: t("mobileCta.valueProp2Body") },
    { icon: Globe2, title: t("mobileCta.valueProp3Title"), body: t("mobileCta.valueProp3Body") },
  ];

  return (
    <section className="md:hidden py-10 bg-background">
      <div className="container">
        <div className="rounded-2xl border border-border/60 bg-card p-6">
          <span className="editorial-subheading text-primary tracking-[0.2em] text-[11px]">
            {t("mobileCta.eyebrow")}
          </span>
          <h2 className="font-display text-[22px] font-semibold mt-2 leading-tight">
            {t("mobileCta.title")}
          </h2>
          <p className="text-sm text-muted-foreground mt-3 leading-relaxed">
            {t("mobileCta.body")}
          </p>

          <div className="mt-5 flex flex-col gap-3">
            <Link
              to={CONSUMER_JOIN_ROUTE}
              className="block w-full"
              onClick={() =>
                track("audience_cta_clicked", {
                  audience: "consumer",
                  intent: "consumer_join",
                  destination: CONSUMER_JOIN_ROUTE,
                  surface: "home_v2_mobile_cta_primary",
                })
              }
            >
              <Button className="w-full min-h-[48px] gap-2 font-medium">
                {t("mobileCta.createAccountCta")} <ArrowRight className="h-4 w-4" />
              </Button>
            </Link>
            <Link
              to={REGISTRY_ROUTE}
              className="block w-full"
              onClick={() =>
                track("audience_cta_clicked", {
                  audience: "consumer",
                  intent: "registry_explore",
                  destination: REGISTRY_ROUTE,
                  surface: "home_v2_mobile_cta_secondary",
                })
              }
            >
              <Button variant="outline" className="w-full min-h-[48px] gap-2 font-medium">
                {t("mobileCta.exploreRegistryCta")}
              </Button>
            </Link>
          </div>
        </div>

        <div className="mt-6 flex flex-col gap-3">
          {valueProps.map((v) => (
            <div
              key={v.title}
              className="rounded-xl border border-border/60 bg-card p-5 flex gap-4 items-start min-h-[112px]"
            >
              <div className="h-10 w-10 rounded-lg bg-primary/10 text-primary flex items-center justify-center flex-shrink-0">
                <v.icon className="h-5 w-5" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-display text-base font-semibold leading-snug">{v.title}</h3>
                <p className="text-[13px] text-muted-foreground mt-1.5 leading-relaxed">{v.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
